// ── BUDGETMODELL ──────────────────────────────────────────────────
// Radtaxonomi och beräkningar — kopierad från Magnus budgetark
// ("# Budget 2025_26": intäkter/direkta kostnader per enhet, övrigt,
// personal fast/säsong, avskrivningar, räntor + likvidmodellens rader).
// Belopp lagras i HELA KRONOR i Firestore; UI:t redigerar i tkr.
//
// Firestore: intel_budget/{bolag}_{ra}_{version}
// { bolag, ra: "2627", version: "B0", status: "utkast"|"faststalld",
//   rader: { "<radId>": { "202607": kr, ... } }, forutsattningar,
//   updatedAt, updatedBy }

export const BOLAG = [
  { id: 'hotell',    namn: 'Hotell Bruksvallsliden AB' },
  { id: 'sc',        namn: 'Bruksvallsliden SC AB' },
  { id: 'stigmyhrs', namn: 'Stigmyhrs Livs AB' },
];

// grupp: intakt | vk | ovrigt | personal | avskr | finans | likvid
// qlikEnhet: Resultatenhet i ledning-cachen (för generator + utfall).
// SC AB:s Sportcenter ligger i samma Qlik-app (Resultatenhet Sportcenter).
const RADER_HOTELL = [
  { id: 'intakt:hotell',      grupp: 'intakt', label: 'Hotell',           qlikEnhet: 'Hotell Logi' },
  { id: 'intakt:formedling',  grupp: 'intakt', label: '– förmedling',     qlikEnhet: 'Hotell Förmedling' },
  { id: 'intakt:aktivitet',   grupp: 'intakt', label: '– aktivitet/spårkort', qlikEnhet: 'Hotell Aktivitet' },
  { id: 'intakt:restaurang',  grupp: 'intakt', label: 'Hotellrestaurangen', qlikEnhet: 'Hotellrestaurangen' },
  { id: 'intakt:brasserie',   grupp: 'intakt', label: 'Brasserie Kerstin', qlikEnhet: 'Brasserie Kerstin' },
  { id: 'intakt:knallen',     grupp: 'intakt', label: 'Knallen',          qlikEnhet: 'Knallen' },
  { id: 'intakt:vavstugan',   grupp: 'intakt', label: 'Vävstugan',        qlikEnhet: 'Vävstugan' },
  { id: 'intakt:stugservice', grupp: 'intakt', label: 'Stugservice',      qlikEnhet: 'Stugservice' },
  { id: 'intakt:oh',          grupp: 'intakt', label: 'O/H & övriga justeringar', qlikEnhet: 'OH' },
  // Skillnaden mellan bokförd 3xxx och summan av Qliks resultatenheter —
  // hyresintäkter, ersättningar och annat som aldrig passerar kassasystemen.
  { id: 'intakt:ovriga',      grupp: 'intakt', label: 'Övriga intäkter (bokföring)' },
  { id: 'vk:hotell',          grupp: 'vk', label: 'Hotell (vk)',          qlikEnhet: 'Hotell Logi' },
  { id: 'vk:formedling',      grupp: 'vk', label: '– förmedling (vk)',    qlikEnhet: 'Hotell Förmedling' },
  { id: 'vk:aktivitet',       grupp: 'vk', label: '– aktivitet (vk)',     qlikEnhet: 'Hotell Aktivitet' },
  { id: 'vk:restaurang',      grupp: 'vk', label: 'Hotellrestaurangen (vk)', qlikEnhet: 'Hotellrestaurangen' },
  { id: 'vk:brasserie',       grupp: 'vk', label: 'Brasserie Kerstin (vk)', qlikEnhet: 'Brasserie Kerstin' },
  { id: 'vk:knallen',         grupp: 'vk', label: 'Knallen (vk)',         qlikEnhet: 'Knallen' },
  { id: 'vk:vavstugan',       grupp: 'vk', label: 'Vävstugan (vk)',       qlikEnhet: 'Vävstugan' },
  { id: 'vk:stugservice',     grupp: 'vk', label: 'Stugservice (vk)',     qlikEnhet: 'Stugservice' },
  // Avstämningsrad: bokförd 4xxx minus Qliks resultatenheter. Får vara
  // negativ — Qlik tar varukostnaden när varan säljs, bokföringen när
  // fakturan kommer, så differensen svänger åt båda håll.
  { id: 'vk:ovriga',          grupp: 'vk', label: 'Övriga direkta kostn. (bokföring)' },
  { id: 'ovrigt:fasta',       grupp: 'ovrigt', label: 'Fasta kostnader' },
  { id: 'ovrigt:ovriga',      grupp: 'ovrigt', label: 'Övriga kostnader' },
  // Koncerngemensamt: ledning, administration, IT, redovisning. Egen rad för
  // att kunna lyftas ur i styrelserapporten — annars ser Hotell ut att gå
  // sämre än dotterbolagen bara för att det bär overheaden åt hela gruppen.
  // Motsvarar kostnadsställe 110 i bokföringen.
  { id: 'ovrigt:oh',          grupp: 'ovrigt', label: 'O/H — koncerngemensamt', oh: true },
  { id: 'personal:fast',      grupp: 'personal', label: 'Fast personal' },
  { id: 'personal:sasong',    grupp: 'personal', label: 'Säsongspersonal' },
  // O/H-personal stannar i personalgruppen — flyttas den till övriga
  // kostnader blir Personal% fel i hela portalen och utfallsvyn slutar
  // stämma mot Qliks lönemått, som räknar in O/H-enheten.
  { id: 'personal:oh',        grupp: 'personal', label: 'O/H — ledning & adm.', oh: true },
  { id: 'avskrivningar',      grupp: 'avskr',  label: 'Avskrivningar' },
  { id: 'rantor',             grupp: 'finans', label: 'Räntekostnader' },
  // Ränteintäkter (bl.a. på lånet till SC AB) ligger i finansgruppen men är
  // en INTÄKT — motpost: true gör att den dras av från gruppens summa i
  // stället för att läggas till. Matas in som positivt tal som allt annat.
  { id: 'finans:ranteintakt', grupp: 'finans', label: 'Ränteintäkter', motpost: true },
  { id: 'likvid:investering', grupp: 'likvid', label: 'Investeringar' },
  { id: 'likvid:amortering',  grupp: 'likvid', label: 'Amorteringar' },
  { id: 'likvid:amortering_skatt', grupp: 'likvid', label: 'Amortering anstånd skatt' },
  // Amortering PÅ lånet till SC AB. Ingen intäkt — bara kapital som kommer
  // tillbaka — så den finns bara i kassaflödet, aldrig i resultatet.
  { id: 'likvid:amortering_in', grupp: 'likvid', label: 'Erhållna amorteringar' },
  { id: 'likvid:extra_in',    grupp: 'likvid', label: 'Extraordinära likv. intäkter' },
  { id: 'likvid:extra_ut',    grupp: 'likvid', label: 'Extraordinära likv. utgifter' },
];

const RADER_SC = [
  { id: 'intakt:sportcenter', grupp: 'intakt', label: 'Sportcenter',      qlikEnhet: 'Sportcenter' },
  { id: 'intakt:ovriga',      grupp: 'intakt', label: 'Övriga intäkter (bokföring)' },
  { id: 'vk:sportcenter',     grupp: 'vk', label: 'Sportcenter (vk)',     qlikEnhet: 'Sportcenter' },
  { id: 'vk:ovriga',          grupp: 'vk', label: 'Övriga direkta kostn. (bokföring)' },
  { id: 'ovrigt:fasta',       grupp: 'ovrigt', label: 'Fasta kostnader' },
  { id: 'ovrigt:ovriga',      grupp: 'ovrigt', label: 'Övriga kostnader' },
  // Koncerngemensamt: ledning, administration, IT, redovisning. Egen rad för
  // att kunna lyftas ur i styrelserapporten — annars ser Hotell ut att gå
  // sämre än dotterbolagen bara för att det bär overheaden åt hela gruppen.
  // Motsvarar kostnadsställe 110 i bokföringen.
  { id: 'ovrigt:oh',          grupp: 'ovrigt', label: 'O/H — koncerngemensamt', oh: true },
  { id: 'personal:fast',      grupp: 'personal', label: 'Fast personal' },
  { id: 'personal:sasong',    grupp: 'personal', label: 'Säsongspersonal' },
  // O/H-personal stannar i personalgruppen — flyttas den till övriga
  // kostnader blir Personal% fel i hela portalen och utfallsvyn slutar
  // stämma mot Qliks lönemått, som räknar in O/H-enheten.
  { id: 'personal:oh',        grupp: 'personal', label: 'O/H — ledning & adm.', oh: true },
  { id: 'avskrivningar',      grupp: 'avskr',  label: 'Avskrivningar' },
  { id: 'rantor',             grupp: 'finans', label: 'Räntekostnader' },
  { id: 'likvid:investering', grupp: 'likvid', label: 'Investeringar' },
  { id: 'likvid:amortering',  grupp: 'likvid', label: 'Amorteringar' },
  { id: 'likvid:extra_in',    grupp: 'likvid', label: 'Extraordinära likv. intäkter' },
  { id: 'likvid:extra_ut',    grupp: 'likvid', label: 'Extraordinära likv. utgifter' },
];

const RADER_STIGMYHRS = [
  // Huvudbutiken (Ramundberget) saknar kassa-API — utfall via bokföringen
  // (SIE): bokförd intäkt minus Lanthandelns HonestBox-oms. ingenVecka:
  // bokföringen är månadsvis, så veckobudgetering saknar underlag.
  { id: 'intakt:huvudbutik',  grupp: 'intakt', label: 'Huvudbutiken', ingenVecka: true },
  { id: 'intakt:lanthandel',  grupp: 'intakt', label: 'Lanthandeln' },
  { id: 'vk:huvudbutik',      grupp: 'vk', label: 'Huvudbutiken (vk)' },
  { id: 'vk:lanthandel',      grupp: 'vk', label: 'Lanthandeln (vk)' },
  { id: 'ovrigt:fasta',       grupp: 'ovrigt', label: 'Fasta kostnader' },
  { id: 'ovrigt:ovriga',      grupp: 'ovrigt', label: 'Övriga kostnader' },
  // Koncerngemensamt: ledning, administration, IT, redovisning. Egen rad för
  // att kunna lyftas ur i styrelserapporten — annars ser Hotell ut att gå
  // sämre än dotterbolagen bara för att det bär overheaden åt hela gruppen.
  // Motsvarar kostnadsställe 110 i bokföringen.
  { id: 'ovrigt:oh',          grupp: 'ovrigt', label: 'O/H — koncerngemensamt', oh: true },
  // Samma raduppdelning som övriga bolag. Stigmyhrs saknar Qlik-koppling,
  // så fast/säsong-panelen är avstängd här — raderna fylls för hand eller
  // ur bokföringen.
  { id: 'personal:fast',      grupp: 'personal', label: 'Fast personal' },
  { id: 'personal:sasong',    grupp: 'personal', label: 'Säsongspersonal' },
  // O/H-personal stannar i personalgruppen — flyttas den till övriga
  // kostnader blir Personal% fel i hela portalen och utfallsvyn slutar
  // stämma mot Qliks lönemått, som räknar in O/H-enheten.
  { id: 'personal:oh',        grupp: 'personal', label: 'O/H — ledning & adm.', oh: true },
  { id: 'avskrivningar',      grupp: 'avskr',  label: 'Avskrivningar' },
  { id: 'rantor',             grupp: 'finans', label: 'Räntekostnader' },
  { id: 'likvid:investering', grupp: 'likvid', label: 'Investeringar' },
  { id: 'likvid:amortering',  grupp: 'likvid', label: 'Amorteringar' },
  { id: 'likvid:extra_in',    grupp: 'likvid', label: 'Extraordinära likv. intäkter' },
  { id: 'likvid:extra_ut',    grupp: 'likvid', label: 'Extraordinära likv. utgifter' },
];

export const RADER = { hotell: RADER_HOTELL, sc: RADER_SC, stigmyhrs: RADER_STIGMYHRS };

// Varukostnads-schabloner (samma som i Qlik) — kopplar vk-rad till
// budgetassistenten: schablon-% av intäktsraden + avdelningsnamnet
// som budgetAssist-funktionen känner igen.
// Ordningen följer matrisens rader (påverkar listningen i schablonknappens
// bekräftelse). Procenten är Qliks varukostnadsschabloner per resultatenhet.
export const VK_SCHABLON = {
  'vk:hotell':      { avdelning: 'Hotell Logi',        pct: 0.10, intaktRad: 'intakt:hotell' },
  'vk:formedling':  { avdelning: 'Hotell Förmedling',  pct: 0.85, intaktRad: 'intakt:formedling' },
  'vk:aktivitet':   { avdelning: 'Hotell Aktivitet',   pct: 0.90, intaktRad: 'intakt:aktivitet' },
  'vk:restaurang':  { avdelning: 'Hotellrestaurangen', pct: 0.30, intaktRad: 'intakt:restaurang' },
  'vk:brasserie':   { avdelning: 'Brasserie Kerstin',  pct: 0.32, intaktRad: 'intakt:brasserie' },
  'vk:knallen':     { avdelning: 'Knallen',            pct: 0.15, intaktRad: 'intakt:knallen' },
  'vk:vavstugan':   { avdelning: 'Vävstugan',          pct: 0.50, intaktRad: 'intakt:vavstugan' },
  'vk:stugservice': { avdelning: 'Stugservice',        pct: 0.10, intaktRad: 'intakt:stugservice' },
  'vk:sportcenter': { avdelning: 'Sportcenter',        pct: 0.65, intaktRad: 'intakt:sportcenter' },
};

// Grupper där belopp är kostnader (matas in som positiva tkr, räknas negativt)
export const KOSTNADSGRUPPER = new Set(['vk', 'ovrigt', 'personal', 'avskr', 'finans']);

// ── LIKVIDITETSMODELL ─────────────────────────────────────────────
// Budgetmatrisen svarar på "tjänar vi pengar", likviditetsmatrisen på
// "räcker pengarna". Samma siffror, men förskjutna till den månad de
// faktiskt rör bankkontot — likviditeten HÄRLEDS ur budgeten och matas
// aldrig in en gång till, annars glider de isär.
//
// Avskrivningar och investeringar är varandras spegelbild: avskrivningen
// är en kostnad utan kassaeffekt, investeringen en utbetalning utan
// kostnad. Räntor finns i båda, amorteringar bara i likviditeten.
export const BETALREGLER = [
  { id: 'samma', label: 'Samma månad', skift: 0 },
  { id: 'plus1', label: '+1 månad',    skift: 1 },
  { id: 'plus2', label: '+2 månader',  skift: 2 },
  { id: 'ingen', label: 'Ingen kassaeffekt', skift: null },
];

// Defaults per grupp.
//
// PERSONAL = +1. Kontrollerat mot data 7 aug 2026: budgetens personalrad
// för juli 26 är exakt Qliks ARBETE i juli (hotell 922 tkr mot 922), inte
// junis. Raden vilar alltså på arbetsmånaden och lönen lämnar kontot
// månaden efter. Följden är att årets första månad saknar sin utbetalning
// — junis löner ligger i föregående räkenskapsår — och den fylls i via
// likvid.ingaendePersonal.
//
// OBS att detta beror på HUR raden byggdes: kördes PersonalSplitPanel med
// "Förskjut 1 mån" påslaget blir raden i stället betalningstajmad och då
// är 'samma' rätt. Regeln går därför att ändra per rad.
//
// Leverantörsfakturor (vk/övrigt) bokförs på fakturadatum och betalas ca
// 30 dagar senare — där är +1 rätt av egen kraft.
export const DEFAULT_BETALREGEL = {
  intakt: 'samma', vk: 'plus1', ovrigt: 'plus1',
  personal: 'plus1', avskr: 'ingen', finans: 'samma',
};

// "202607" + 1 → "202608"
export function forskjutYm(ym, steg) {
  let y = Number(ym.slice(0, 4)), m = Number(ym.slice(4)) + (steg || 0);
  y += Math.floor((m - 1) / 12);
  m = ((m - 1) % 12 + 12) % 12 + 1;
  return `${y}${String(m).padStart(2, '0')}`;
}

// Alla månadsnycklar mellan två ym (inklusive båda ändar)
export function manaderMellan(fran, till) {
  const ut = [];
  let ym = fran;
  for (let i = 0; i < 120 && ym <= till; i++) { ut.push(ym); ym = forskjutYm(ym, 1); }
  return ut;
}

/**
 * Härleder kassaflödet ur budgetraderna.
 *
 * likvid = {
 *   betalregler: { radId: 'samma'|'plus1'|'plus2'|'ingen' },
 *   forskott: [{ id, rad, belopp, betalMan, intjanadFran, intjanadTill, kommentar }],
 *   ingaendeBank: kr, ingaendeSkulder: kr, ingaendePersonal: kr,
 * }
 *
 * ingaendeSkulder/ingaendePersonal betalas i årets första månad. De fångar
 * juni månads leverantörsfakturor och löner, som ligger i föregående
 * räkenskapsårs budget och därför aldrig når fram via förskjutningen.
 *
 * Förskott flyttar kassa från intjänandemånad till betalmånad, viktat mot
 * budgeterat belopp i intjänandemånaderna. Årssumman ändras aldrig — det
 * är en inbyggd kontroll att inget dubbelräknas. Betalmånader utanför
 * räkenskapsåret faller naturligt bort (pengarna kom ett annat år).
 */
export function beraknaLikviditet({ bolag, rader, likvid, manader }) {
  const def = RADER[bolag] || [];
  const regler = likvid?.betalregler || {};
  const forskott = likvid?.forskott || [];

  const flode = {};                       // radId → ym → kr (+ in, − ut)
  const lagg = (radId, ym, kr) => {
    if (!kr) return;
    (flode[radId] || (flode[radId] = {}))[ym] = (flode[radId][ym] || 0) + kr;
  };

  for (const rad of def) {
    if (rad.grupp === 'likvid') continue;  // egna rader, ingen förskjutning
    const regelId = regler[rad.id] || DEFAULT_BETALREGEL[rad.grupp] || 'samma';
    const regel = BETALREGLER.find((b) => b.id === regelId) || BETALREGLER[0];
    if (regel.skift === null) continue;    // avskrivningar
    const tecken = (KOSTNADSGRUPPER.has(rad.grupp) && !rad.motpost) ? -1 : 1;
    for (const [ym, kr] of Object.entries(rader?.[rad.id] || {})) {
      lagg(rad.id, forskjutYm(ym, regel.skift), tecken * (kr || 0));
    }
  }

  for (const f of forskott) {
    const belopp = f.belopp || 0;
    if (!belopp || !f.rad || !f.betalMan) continue;
    const varden = rader?.[f.rad] || {};
    const kallMan = manaderMellan(f.intjanadFran, f.intjanadTill || f.intjanadFran);
    const vikter = kallMan.map((m) => Math.max(0, varden[m] || 0));
    const summa = vikter.reduce((a, b) => a + b, 0);
    kallMan.forEach((m, i) => {
      lagg(f.rad, m, -(summa > 0 ? belopp * vikter[i] / summa : belopp / kallMan.length));
    });
    lagg(f.rad, f.betalMan, belopp);
  }

  for (const rad of def) {
    if (rad.grupp !== 'likvid') continue;
    const tecken = rad.id.endsWith('_in') ? 1 : -1;
    for (const [ym, kr] of Object.entries(rader?.[rad.id] || {})) lagg(rad.id, ym, tecken * (kr || 0));
  }

  // Avstämt banksaldo: verkligt saldo vid en månads utgång. Modellens saldo
  // ersätts där och kurvan fortsätter från verkligheten. Skillnaden redovisas
  // som en egen justering — den visar hur långt modellen låg ifrån, i
  // stället för att tyst skrivas in i något flöde.
  const avst = likvid?.avstamning;
  const avstYm = avst && avst.ym && Number.isFinite(avst.bank) ? avst.ym : null;

  let saldo = likvid?.ingaendeBank || 0;
  const perManad = manader.map((ym, i) => {
    let inbet = 0;
    let utbet = i === 0 ? (likvid?.ingaendeSkulder || 0) + (likvid?.ingaendePersonal || 0) : 0;
    for (const radId of Object.keys(flode)) {
      const v = flode[radId][ym] || 0;
      if (v > 0) inbet += v; else utbet -= v;
    }
    const ingaende = saldo;
    saldo += inbet - utbet;
    let justering = 0;
    if (ym === avstYm) { justering = avst.bank - saldo; saldo = avst.bank; }
    return { ym, ingaende, inbet, utbet, netto: inbet - utbet, justering, utgaende: saldo, avstamd: ym === avstYm };
  });

  return { flode, perManad, lagsta: perManad.reduce((a, b) => (b.utgaende < a.utgaende ? b : a), perManad[0]) };
}

export const GRUPP_LABELS = {
  intakt: 'Rörelsens intäkter', vk: 'Direkta kostnader', ovrigt: 'Övriga kostnader',
  personal: 'Personalkostnader', avskr: 'Avskrivningar', finans: 'Finansiella poster',
  likvid: 'Likviditetsposter',
};

// ── VECKOBUDGET-HJÄLPARE ──────────────────────────────────────────
// RÅ "2627" → ISO-veckonycklar [202627..202653?, 202701..202726]
export function raVeckor(ra) {
  const y1 = 2000 + Number(ra.slice(0, 2));
  const jan1 = new Date(Date.UTC(y1, 0, 1)).getUTCDay();
  const dec31 = new Date(Date.UTC(y1, 11, 31)).getUTCDay();
  const n = (jan1 === 4 || dec31 === 4) ? 53 : 52;
  return [
    ...Array.from({ length: n - 26 }, (_, i) => y1 * 100 + 27 + i),
    ...Array.from({ length: 26 }, (_, i) => (y1 + 1) * 100 + 1 + i),
  ];
}

// Måndagen för en ISO-vecka (nyckel yyyyww) som Date (UTC 12:00)
export function isoMandag(veckoKey) {
  const y = Math.floor(veckoKey / 100), w = veckoKey % 100;
  const jan4 = new Date(Date.UTC(y, 0, 4, 12));
  const dow = (jan4.getUTCDay() + 6) % 7;
  const d = new Date(jan4);
  d.setUTCDate(jan4.getUTCDate() - dow + (w - 1) * 7);
  return d;
}

// Fördela veckobelopp på månader (1/7 per dag) → { "YYYYMM": kr }
// Används när veckobudgeten rullas upp till månadsmatrisen.
export function veckorTillManader(veckoVarden) {
  const perMan = {};
  for (const [key, kr] of Object.entries(veckoVarden)) {
    const belopp = kr || 0;
    if (!belopp) continue;
    const mon = isoMandag(Number(key));
    for (let i = 0; i < 7; i++) {
      const d = new Date(mon); d.setUTCDate(mon.getUTCDate() + i);
      const ym = `${d.getUTCFullYear()}${String(d.getUTCMonth() + 1).padStart(2, '0')}`;
      perMan[ym] = (perMan[ym] || 0) + belopp / 7;
    }
  }
  for (const ym of Object.keys(perMan)) perMan[ym] = Math.round(perMan[ym]);
  return perMan;
}

// RÅ "2627" → månadsnycklar ["202607",...,"202706"]
export function raManader(ra) {
  const y1 = 2000 + Number(ra.slice(0, 2));
  return Array.from({ length: 12 }, (_, i) => {
    const mm = ((6 + i) % 12) + 1;
    const yy = mm >= 7 ? y1 : y1 + 1;
    return `${yy}${String(mm).padStart(2, '0')}`;
  });
}
export const MANAD_LABELS = ['jul', 'aug', 'sep', 'okt', 'nov', 'dec', 'jan', 'feb', 'mar', 'apr', 'maj', 'jun'];

// Summeringar per månad ur rader-objektet (kr, kostnader lagras positiva).
// Returnerar { intakter, direkta, ovriga, personal, rorelsensKostn,
//              driftsresultat, avskr, finans, resultat, likvidResultat } per månad.
export function summering(rader, raderDef, manader) {
  // motpost-rader (t.ex. Ränteintäkter i finansgruppen) är intäkter i en
  // kostnadsgrupp och dras därför av i stället för att läggas till.
  const sumGrupp = (grupp, m) => raderDef
    .filter((r) => r.grupp === grupp)
    .reduce((s, r) => s + (r.motpost ? -1 : 1) * ((rader[r.id] || {})[m] || 0), 0);
  const out = {};
  for (const m of manader) {
    const intakter = sumGrupp('intakt', m);
    const direkta = sumGrupp('vk', m);
    const ovriga = sumGrupp('ovrigt', m);
    const personal = sumGrupp('personal', m);
    const avskr = sumGrupp('avskr', m);
    const finans = sumGrupp('finans', m);
    const rorelsensKostn = direkta + ovriga + personal;
    const driftsresultat = intakter - rorelsensKostn;
    const resultat = driftsresultat - avskr - finans;
    // Likvidposter summeras generiskt: rader vars id slutar på _in är
    // inbetalningar, övriga utbetalningar. Slipper hårdkodade radlistor som
    // tyst missar nya rader (investeringar var en sådan lucka).
    const likvidNetto = raderDef
      .filter((r) => r.grupp === 'likvid')
      .reduce((s, r) => s + (r.id.endsWith('_in') ? 1 : -1) * ((rader[r.id] || {})[m] || 0), 0);
    const likvidResultat = driftsresultat - finans + likvidNetto;
    out[m] = { intakter, direkta, ovriga, personal, rorelsensKostn, driftsresultat, avskr, finans, resultat, likvidResultat };
  }
  return out;
}
